import { currencySymbol } from "./currency";

/** « 1 500 000 FG » dans la devise de l'école (espaces simples : lisibles à l'écran comme sur un PDF). */
export function formatMoney(amount: number): string {
  // Espaces insécables : un montant ne se coupe jamais en deux lignes (« 830 000 / FG »), à l'écran comme en PDF.
  return `${Math.round(amount).toLocaleString("fr-FR").replace(/[   ]/g, " ")} ${currencySymbol()}`;
}

export function formatDate(iso: string): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function formatLongDate(iso: string): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("fr-FR", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export function todayISO(): string {
  return new Date().toISOString().slice(0, 10);
}

export function initials(lastName: string, firstName: string): string {
  return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
}
/** « 1 inscription », « 48 inscriptions » : 0 et 1 au singulier (règle française). */
export function plural(count: number, singular: string, pluralForm = `${singular}s`): string {
  return `${count.toLocaleString("fr-FR")} ${Math.abs(count) >= 2 ? pluralForm : singular}`;
}
